import { useCountdown, pad } from "@/hooks/use-countdown";
import { PRICE_NEW, scrollToId } from "@/constants/site";

const UrgencyBar = () => {
  const { hours, minutes, seconds } = useCountdown();

  return (
    <div data-testid="urgency-bar" className="bg-accent text-accent-foreground">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-x-3 gap-y-1 px-4 py-1.5 text-xs sm:px-6 sm:text-sm lg:px-8">
        <span className="hidden font-medium sm:inline">
          Oferta de lançamento por {PRICE_NEW} expira em
        </span>
        <span className="font-medium sm:hidden">{PRICE_NEW} expira em</span>
        <span
          data-testid="urgency-bar-timer"
          className="font-mono-accent font-semibold tabular-nums tracking-wide"
        >
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
        <button
          data-testid="urgency-bar-cta"
          onClick={() => scrollToId("#oferta")}
          className="font-semibold underline underline-offset-2 transition-opacity duration-300 hover:opacity-80"
        >
          Garantir agora
        </button>
      </div>
    </div>
  );
};

export default UrgencyBar;
